import React from 'react';
import { NoData } from 'src/@vymo/ui/blocks';
import { Widget } from 'src/@vymo/ui/molecules';
import { Keys, locale } from 'src/i18n';
import { getPerformanceCards } from 'src/models/lmsConfig/selectors';
import { useAppSelector } from 'src/store/hooks';
import KeyMetricsWidget from './keyMetricsWidget';
import LeaderboardWidget from './leaderboardWidget';
import styles from '../index.module.scss';

function Dashboard() {
  const performanceCards = useAppSelector(getPerformanceCards);

  const getDashboardCard = (card: any) => {
    switch (card?.code) {
      case 'leaderboard':
        return <LeaderboardWidget />;
      case 'key_metrics':
        return (
          <KeyMetricsWidget classNames={styles.dashboardWrapper__wideCard} />
        );
      default:
        return (
          <Widget
            title={card?.title}
            content={<NoData message={locale(Keys.COMING_SOON)} />}
          />
        );
    }
  };

  return (
    <div className={styles.dashboardWrapper}>
      {performanceCards?.map((card) => getDashboardCard(card))}
    </div>
  );
}

export default Dashboard;
